import { defaultResolveTxt } from "@/components/field-element.ts";

const resolveTxt = defaultResolveTxt;
const displayParams = false;
const getService = () => ({});
const getMenu = (name) => null;

const services = {
  resolveTxt: resolveTxt,
  displayParams: displayParams,
  getService: getService,
  getMenu: getMenu
};

export default services;
